module.exports = __webpack_public_path__ + "media/components/assets/img/logo/mono/gray/american-express-3a3ce0d62d218e10a9e30ab4f4f0c096.png";